import { Box, SxProps, Theme } from '@mui/material';

import { EmptyState } from '@/components/EmptyState';
import { DashboardCustomize as DashboardCustomizeIcon } from '@mui/icons-material';

const styles = {
  root: {
    width: '100%',
    height: '100%',
    borderRadius: 2,
    border: (theme: Theme) => `4px dashed ${theme.palette.baseColors.gray.c100}`,
    color: (theme: Theme) => theme.palette.baseColors.deepSeaNavy.c75,

    svg: {
      aspectRatio: '1/1',
      width: 'auto',
      height: 'clamp(1rem, 50%, 3rem)',
      opacity: 0.25,
    },
  },
};

type PlaceholderProps = {
  sx?: SxProps<Theme>;
};

const PLACEHOLDER_TEXT = 'Drag and Drop Component Here';

export const Placeholder = ({ sx }: PlaceholderProps) => {
  return (
    <Box sx={{ ...styles.root, ...sx }}>
      <EmptyState Icon={DashboardCustomizeIcon} title={PLACEHOLDER_TEXT} />
    </Box>
  );
};

export const PlaceholderPreview = ({ sx = {} }) => {
  return (
    <Box
      sx={{
        ...styles.root,
        borderRadius: 1,
        border: 'none',
        backgroundColor: (theme) => theme.palette.baseColors.gray.c100,
        ...sx,
      }}
    ></Box>
  );
};
